module.exports = __webpack_public_path__ + "static/media/a28.99dbcb38.pdf";